<template>
  <!-- Bottom sheet on mobile, centered dialog on desktop -->
  <v-bottom-sheet
    v-if="isMobile"
    v-model="model"
    @update:model-value="onDialogUpdate"
  >
    <v-card class="pa-4 pb-6">
      <access-code-form
        v-model="accessCodeInput"
        :error-message="errorMessage"
        :loading="loading"
        @submit="onSubmit"
        @cancel="onCancel"
      />
    </v-card>
  </v-bottom-sheet>

  <v-dialog
    v-else
    v-model="model"
    max-width="420"
    @update:model-value="onDialogUpdate"
  >
    <v-card class="pa-4">
      <access-code-form
        v-model="accessCodeInput"
        :error-message="errorMessage"
        :loading="loading"
        @submit="onSubmit"
        @cancel="onCancel"
      />
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { useDisplay } from "vuetify";
import AccessCodeForm from "./access-code-form.vue";

const display = useDisplay();
const isMobile = computed(() => display.smAndDown.value);

const model = defineModel<boolean>({ default: false });

defineProps<{
  loading?: boolean;
  errorMessage?: string | null;
}>();

const emit = defineEmits<{
  submit: [accessCode: string];
  cancel: [];
}>();

const accessCodeInput = ref("");

// Reset input when dialog opens
watch(model, (open) => {
  if (open) {
    accessCodeInput.value = "";
  }
});

function onSubmit() {
  emit("submit", accessCodeInput.value);
}

function onCancel() {
  model.value = false;
  emit("cancel");
}

function onDialogUpdate(value: boolean) {
  if (!value) {
    emit("cancel");
  }
}
</script>
